import type { ContentTooltipSize } from "./content-tooltip-types";

/**
 * Default open delay (ms) — shared across all ContentTooltip bags / call sites.
 * Override via `delayDuration` only when a surface truly needs a different cadence.
 */
export const CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS = 0;

/**
 * Size tokens for ContentTooltip panels.
 * Radius is `rounded-md` for all sizes (Radix leftover / shadcn-core parity).
 */
export const CONTENT_TOOLTIP_SIZE_CLASS: Record<ContentTooltipSize, string> = {
	sm: "rounded-md px-2.5 py-1 text-xs",
	md: "rounded-md px-3 py-1.5 text-sm",
	lg: "rounded-md px-3.5 py-2 text-sm leading-snug",
};

export function contentTooltipSizeClass(size: ContentTooltipSize): string {
	return CONTENT_TOOLTIP_SIZE_CLASS[size];
}
